var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.text),expression:"text"}],ref:"textarea",attrs:{"placeholder":_vm.placeholder},domProps:{"value":(_vm.text)},on:{"keydown":function($event){return _vm.setHeight()},"input":function($event){if($event.target.composing)return;_vm.text=$event.target.value}}})
}
var staticRenderFns = []

export { render, staticRenderFns }